<template>
  <full-calendar :header-show="false" :events="filteredWorkList" locale="ko" :selected-date="selectedDate" @eventClick="onEventClick" @calendarNumberClick="onClickCalendarNumber" @dayClick="onClickDay">
  </full-calendar>
</template>

<script>
import { clone, isEmpty } from 'lodash';
import FullCalendar from '@/components/external/vue-fullcalendar/fullCalendar';
import workManageAPI from '@/api/work/work';

export default {
  name: 'WWorkCalendar',
  components: { FullCalendar },
  props: {
    selectedDate: Date,
    filteringConfig: Object,
  },
  data() {
    return {
      workList: [],
      filteredWorkList: [],
      searchKeyword: '',
    };
  },
  watch: {
    selectedDate: {
      handler(newValue, oldValue) {
        if (!oldValue || newValue.getFullYear() !== oldValue.getFullYear() || newValue.getMonth() !== oldValue.getMonth()) {
          // 다른 날짜(년, 월) 선택시 load
          this.loadData();
        }
      },
      immediate: true,
    },
    filteringConfig: {
      handler() {
        this.filteringWorkList();
      },
      deep: true,
    },
  },
  methods: {
    /**
     * 작업 내역 (달력) 데이터 조회
     * @author jeee12
     */
    loadData() {
      workManageAPI.getWorkListForCalendar({ selectedDate: this.selectedDate }).then((response) => {
        if (response.data.success === true) {
          const resultList = response.data.data;
          const workList = [];
          resultList.forEach((result) => {
            const title = result.objCount > 1 ? `${result.workName} / ${result.objName} 외 ${result.objCount - 1}종` : `${result.workName} / ${result.objName}`;
            const work = {
              title,
              start: new Date(result.startDatetime),
              end: new Date(result.endDatetime),
              data: result,
              slotClass: isEmpty(result.workImpact) ? 'workimpact-grade_null' : `workimpact-${result.workImpact.toLowerCase()}`,
              cssClass: `worktype-${result.workTypeId.toLowerCase()}`,
            };
            workList.push(work);
          });
          this.workList = workList;
          this.filteringWorkList();
        }
      });
    },
    /**
     * 검색 필터링
     * @author jeee12
     */
    search(searchValue) {
      this.searchKeyword = searchValue;
      this.filteringWorkList();
    },
    /**
     * 작업내역 조건별 필터링 (작업별, 영향도별, 스케줄링, 검색)
     * @author jeee12
     */
    filteringWorkList() {
      const workImpact = this.filteringConfig.workImpact;
      const workSchedule = this.filteringConfig.workSchedule;
      const workType = this.filteringConfig.workType;
      let resultList = clone(this.workList);
      resultList = resultList.filter((work) => {
        const workData = work.data;
        if (workSchedule.indexOf(workData.scheduleType) > -1 && workType.indexOf(workData.workTypeId) > -1) {
          const grade = isEmpty(workData.workImpact) ? 'GRADE_NULL' : workData.workImpact;
          return workImpact.indexOf(grade) > -1;
        }
        return false;
      });
      this.filteredWorkList = resultList;

      if (!isEmpty(this.searchKeyword)) {
        const searchKeyword = this.searchKeyword.toLowerCase();
        this.filteredWorkList = this.filteredWorkList.filter((work) => work.data.workName.toLowerCase().indexOf(searchKeyword) > -1 || work.data.objNameData.toLowerCase().indexOf(searchKeyword) > -1);
      }
    },
    /**
     * 달력 날짜 영역 클릭
     * @author jeee12
     * @param  {[type]} date [description]
     */
    onClickCalendarNumber(date) {
      this.$emit('calendar-number-click', date);
    },
    onEventClick(work) {
      // 작업 내역 클릭
      this.$emit('workClick', work.data);
    },
    onClickDay(day) {
      this.$emit('day-click', day);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/work/components/WorkCalendar.vue